
            const data = {"name":"arrow-up","data":{"width":"8","height":"24","viewBox":"0 0 8 24","data":"<path pid=\"0\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.707 4.293a1 1 0 0 0-1.414 0L.464 7.12A1 1 0 0 0 1.88 8.536L3 7.414V18a1 1 0 1 0 2 0V7.414l1.121 1.122A1 1 0 1 0 7.536 7.12L4.707 4.293Z\" _fill=\"#4CAB26\"/>","originalColors":[{"type":"fill","color":"#4CAB26"}],"stopColors":[]}}
        
                    module.exports = data
                    